import React from "react";
import { Fade } from "react-reveal";

export default function Contact() {
  return (
    <Fade left cascade>
      <div className="flex flex-col items-center justify-center flex-grow px-8 mt-24 mb-2 lg:space-x-4 max-lg:space-y-4 md:px-12 lg:px-16 lg:flex-row">
        <div className="max-lg:w-full">
          <a
            href="https://www.linkedin.com/in/mesanfaz"
            className="hover:shadow-2xl duration-500 flex flex-row items-center justify-center hover:text-white border border-mesanfaz-black hover:bg-mesanfaz-black rounded-lg lg:w-44 xl:w-60 2xl:w-72 max-md:py-3 md:py-4 lg:py-2.5"
          >
            <div>
              <img
                src={process.env.PUBLIC_URL + "/svg-linkedin.svg"}
                alt="linkedin-logo"
                className="w-8 h-8"
              />
            </div>
            <div className="ml-2">LinkedIn</div>
          </a>
        </div>
        <div className="max-lg:w-full">
          <a
            href="https://wa.me/6285162566473"
            className="hover:shadow-2xl duration-500 flex flex-row items-center justify-center hover:text-white border border-mesanfaz-black hover:bg-mesanfaz-black rounded-lg lg:w-44 xl:w-60 2xl:w-72 max-md:py-3 md:py-4 lg:py-2.5"
          >
            <div>
              <img
                src={process.env.PUBLIC_URL + "/svg-whatsapp.svg"}
                alt="linkedin-logo"
                className="w-8 h-8"
              />
            </div>
            <div className="ml-2">WhatsApp</div>
          </a>
        </div>
        <div className="max-lg:w-full">
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=michsanfauzan.job@gmail.com"
            className="hover:shadow-2xl duration-500 flex flex-row items-center justify-center hover:text-white border border-mesanfaz-black hover:bg-mesanfaz-black rounded-lg lg:w-44 xl:w-60 2xl:w-72 max-md:py-3 md:py-4 lg:py-2.5"
          >
            <div>
              <img
                src={process.env.PUBLIC_URL + "/svg-gmail.svg"}
                alt="linkedin-logo"
                className="w-8 h-8"
              />
            </div>
            <div className="ml-2">Gmail</div>
          </a>
        </div>
        <div className="max-lg:w-full">
          <a
            href="https://github.com/mesxx"
            className="hover:shadow-2xl duration-500 flex flex-row items-center justify-center hover:text-white border border-mesanfaz-black hover:bg-mesanfaz-black rounded-lg lg:w-44 xl:w-60 2xl:w-72 max-md:py-3 md:py-4 lg:py-2.5"
          >
            <div>
              <img
                src={process.env.PUBLIC_URL + "/svg-github.svg"}
                alt="linkedin-logo"
                className="w-8 h-8"
              />
            </div>
            <div className="ml-2">Github</div>
          </a>
        </div>
      </div>
    </Fade>
  );
}
